import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'react-hot-toast';


import Login from "../pages/Login/";
import Main from "../pages/Main/";
import Pagamento from "../pages/Pagamento/";
import SignUpConfirmation from "../pages/SignUpConfirmation";
import Verificacao from "../pages/Verificacao";


const Rotas = () => {

  return (
    <BrowserRouter>
        <Routes>
        <Route index element={<Login />} isPrivate />
        <Route index element={<Main />} isPrivate />
        <Route index element={<Pagamento />} isPrivate />
        <Route index element={<SignUpConfirmation />} isPrivate />
        <Route index element={<Verificacao />} isPrivate />
        <Route index path="/login" element={<Login />} />
        <Route index path="/main" element={<Main />} />
        <Route index path="/pagamento" element={<Pagamento />} />
        <Route index path="/signUpConfirmation" element={<SignUpConfirmation />} />
        <Route index path="/verificacao" element={<Verificacao />} />
          
        </Routes>
        <Toaster />
    </BrowserRouter>
  );
};
export default Rotas;
